'use strict';

module.exports = function toggle24Hr(groups) {
  var m = groups[groups.length - 1].toUpperCase();
  groups[groups.length - 1] = m === 'AM' ? 'PM' : 'AM';
  return groups;
};


//////////////////
// WEBPACK FOOTER
// ./~/time-input/dist/lib/toggle-24-hour.js
// module id = 1725
// module chunks = 0